import { useEffect, useState } from 'react'
import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/UI'

const defaultForm = {
  name: '',
  projectType: 'casa',
  description: '',
  countryCode: 'CO',
  currencyCode: 'COP',
  unitSystem: 'metric',
  timeZone: 'America/Bogota',
  rulesetId: null,
}

const COUNTRY_TO_CURRENCY = { CO: 'COP', MX: 'MXN', US: 'USD', PE: 'PEN', CL: 'CLP' }

export default function MCProjectCreateForm({ rulesets = [], onSubmit, loading = false }) {
  const [form, setForm] = useState(defaultForm)

  useEffect(() => {
    if (!form.rulesetId && rulesets.length) {
      setForm((prev) => ({ ...prev, rulesetId: rulesets[0].id }))
    }
  }, [rulesets, form.rulesetId])

  const update = (key, value) => {
    if (key === 'countryCode') {
      const cc = value.toUpperCase()
      setForm((prev) => ({ ...prev, countryCode: cc, currencyCode: COUNTRY_TO_CURRENCY[cc] || prev.currencyCode }))
      return
    }

    setForm((prev) => ({ ...prev, [key]: value }))
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    onSubmit({ ...form, name: form.name.trim() })
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Crear proyecto</CardTitle>
        <CardDescription>Configura los datos base y abre el asistente.</CardDescription>
      </CardHeader>
      <CardContent>
        <form className="space-y-3" onSubmit={handleSubmit}>
          <input className="w-full rounded-lg border px-3 py-2 text-sm" placeholder="Nombre" value={form.name} minLength={3} required onChange={(e) => update('name', e.target.value)} />
          <select className="w-full rounded-lg border px-3 py-2 text-sm" value={form.projectType} onChange={(e) => update('projectType', e.target.value)}>
            <option value="casa">Casa</option>
            <option value="apartamento">Apartamento</option>
            <option value="torre">Torre</option>
            <option value="otro">Otro</option>
          </select>
          <textarea className="w-full rounded-lg border px-3 py-2 text-sm" rows={3} placeholder="Descripción" value={form.description} onChange={(e) => update('description', e.target.value)} />
          <div className="grid grid-cols-2 gap-2">
            <input className="rounded-lg border px-3 py-2 text-sm" value={form.countryCode} onChange={(e) => update('countryCode', e.target.value)} required />
            <input className="rounded-lg border px-3 py-2 text-sm" value={form.currencyCode} onChange={(e) => update('currencyCode', e.target.value)} />
          </div>
          <div className="grid grid-cols-2 gap-2">
            <select className="rounded-lg border px-3 py-2 text-sm" value={form.unitSystem} onChange={(e) => update('unitSystem', e.target.value)}>
              <option value="metric">Métrico</option>
              <option value="imperial">Imperial</option>
            </select>
            <input className="rounded-lg border px-3 py-2 text-sm" value={form.timeZone} onChange={(e) => update('timeZone', e.target.value)} />
          </div>
          <select className="w-full rounded-lg border px-3 py-2 text-sm" value={form.rulesetId || ''} onChange={(e) => update('rulesetId', e.target.value || null)}>
            <option value="">Sin conjunto de reglas</option>
            {rulesets.map((ruleset) => (
              <option key={ruleset.id} value={ruleset.id}>{ruleset.ruleKey} {ruleset.version}</option>
            ))}
          </select>
          <Button fullWidth type="submit" loading={loading}>Crear y abrir asistente</Button>
        </form>
      </CardContent>
    </Card>
  )
}
